import { Component } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { ChequeBookFormComponent } from "../cheque-book-form/cheque-book-form.component";

@Component({
  selector: "ngx-cheque-book-list",
  templateUrl: "./cheque-book-list.component.html",
  styleUrls: ["./cheque-book-list.component.scss"],
})
export class ChequeBookListComponent extends BaseListComponent {
  constructor() {
    super();
    this.inputEditorform = ChequeBookFormComponent;
  }
  ngOnInit() {
    this.apiName = "ChequeBookHeader";
    this.areaName = "Treasury";
    this.label = "دسته چک";
  }
}
